
import Vue from 'vue';

// A small label on the Feedback admin page: a report's kind, status, priority, that an admin sent
// it, or that an agent filed or imported it. `kind` picks its colour: kind-bug, status-approved,
// priority-p0, admin, origin-import, and so on.
export default Vue.extend({
	name: 'FeedbackChip',
	props: {
		kind: { type: String, required: true },
		label: { type: String, required: true },
	},
});
